<template>
  <v-carousel continuous cycle height="100vh" hide-delimiter-background hide-delimiters :show-arrows="false"
    :show-indicators="false" >
    <v-carousel-item v-for="(image, idx) in images" :key="idx">
      <v-img :src="image" height="100%" width="100%" />
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  props: {
    seeder: {
      type: Number,
      default: 10,
    },
    images: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
};
</script>
